import { useContext } from 'react';
import { intl, LanguageBaseContext } from "dmsbasereact";

export const useQualityIssues = () => {
    // Re-evaluate translations when language changes
    return {
        CAPSULE_ALTERATION: intl.get("CapsuleAlteration").d("Capsule Alteration"),
        MISSING_CAPSULE: intl.get("MissingCapsule").d("Missing Capsule"),
        PRIMARY_PACKAGING_ALTERATION: intl.get("PrimaryPackagingAlteration").d("Primary Packaging Alteration"),
        SECONDARY_PACKAGING_ALTERATION: intl.get("SecondaryPackagingAlteration").d("Secondary Packaging Alteration"),
        FOREIGN_BODY: intl.get("ForeignBody").d("Foreign Body"),
        CRACKED_TABLETS: intl.get("CrackedTablets").d("Cracked/Broken Tablets"),
    };
};

export const useQualityIssueOptions = () => {
    const qualityIssues = useQualityIssues();

    return Object.entries(qualityIssues).map(([key, value]) => ({
        value: key,
        label: value
    }));
};
